export const MATERIAL_BRAND_EXPORT_ID = 'material-brand';

export const MATERIAL_BRAND_TITLE = 'Marcas';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  company: 'Compañia',
  statusId: 'Estado',
};
